import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * GET api/Onboarding/entity-kyc-status/{id}
 * Returns { isDocumentUploaded: boolean }
 */
export const entityKycStatusAction = async (id) => {
  try {
    const response = await apiClient.get(
      `${ATP_API_URL.ENTITY_KYC_STATUS}/${id}`,
    );
    if (response?.status === 200 && response.data) {
      return {
        success: true,
        isDocumentUploaded: response.data.isDocumentUploaded === true,
      };
    }
    return { success: false, isDocumentUploaded: false };
  } catch (error) {
    console.warn("[KycStatus] Error:", error.message);
    return { success: false, isDocumentUploaded: false, error: error.message };
  }
};
